import {
    RequestOptions,
    RequestParams,
    RequestQueryOptions,
    useInvalidateQuery,
    useOptimisticUpdate,
} from '@approvalmax/data';
import { useGet, useLazyGet } from 'shared/data/api';

import { kycApiPaths } from '../paths';
import { GetKyc } from './useGetKyc.types';

export const useGetKyc = (
    params?: RequestParams<GetKyc>,
    queryOptions?: RequestQueryOptions<GetKyc>,
    options?: RequestOptions
) =>
    useGet(kycApiPaths.kyc, {
        params,
        queryOptions,
        apiSource: 'walletsKyc',
        apiVersion: 'v1',
        ...options,
    });

export const useLazyGetKyc = (queryOptions?: RequestQueryOptions<GetKyc>, options?: RequestOptions) =>
    useLazyGet<GetKyc>(kycApiPaths.kyc, {
        queryOptions,
        apiSource: 'walletsKyc',
        apiVersion: 'v1',
        ...options,
    });

export const useKycOptimisticUpdate = () => useOptimisticUpdate<GetKyc>(kycApiPaths.kyc);

export const useInvalidateGetKyc = () => useInvalidateQuery<RequestParams<GetKyc>>(kycApiPaths.kyc);
